import React from 'react'

import { PaymentResult } from '../../../features/payment-result'

export const PaymentResultPage = () => {
  return <PaymentResult />
}
